export default {
  message: {
    welcome:'Chào mừng đến với Huayan Juzhu',
    search: 'Tìm kiếm',
    placeHolder: 'Vui lòng nhập từ khóa để tìm kiếm',
    quantity: 'Số lượng',
    color: 'Màu sắc',
    design: 'Cơ sở thiết kế',
    specifications: 'Thông số kỹ thuật',
    China: 'Trung Quốc',
    MinimumOrder: 'Đơn hàng tối thiểu',
    squareMeter: 'mét vuông',
    thickness: 'Độ dày',
    price: 'Giá',
    material: 'Chất liệu',
    sendEmail: 'Gửi email',
    phoneCall: 'Gọi điện',
    ProductDetails: 'Chi tiết sản phẩm',
    Ltd: 'Công ty TNHH Đá Xuchang Shitaocheng',
    name: 'Vương Ninh Ba',
    Tel: 'Điện thoại',
    SalesManager: 'Quản lý kinh doanh',
    ContactTheSupplier: 'Liên hệ nhà cung cấp',
    languageList: {
      item0: 'Tiếng Trung Giản thể',
      item1: 'Tiếng Anh',
      item2: 'Tiếng Ả Rập',
      item3: 'Tiếng Việt',
      // item4: 'Tiếng Indonesia'
    },
    desc: 'Thông qua Internet công nghiệp, Huayan Juzhu đã xây dựng hệ thống chuỗi cung ứng đá toàn cầu hoàn chỉnh, xây dựng ma trận sản phẩm riêng, tối ưu hóa bố cục sinh thái thượng nguồn và hạ nguồn của ngành công nghiệp. Kể từ khi thành lập vào năm 2020, gần 20 cửa hàng trung tâm đã bao phủ Hà Nam, An Huy, Sơn Đông, Hồ Nam, Hà Bắc, Thiên Tân, Bắc Kinh. Doanh số bán đá nhân tạo chính hàng năm đạt 3,6 triệu mét khối, trở thành nhà sản xuất và phân phối đá nhân tạo lớn nhất trong nước, với 3 triệu mét khối đá granite, hơn 500.000 mét khối đá thạch anh và hơn 200.000 mét khối tấm đá, trở thành người dẫn đầu trong ngành công nghiệp nội địa. Thông qua Internet, không ngừng tối ưu hóa cấu trúc chuỗi cung ứng để cung cấp dịch vụ tốt hơn, cải thiện mô hình bán lẻ hiện có, sử dụng dữ liệu lớn và phần mềm thông minh cùng phần cứng, vượt qua trải nghiệm bán buôn đá truyền thống.'
  }
}